const DATE_PICKER_COMPARATOR_MODULE = '[date-picker-comparitor]';

const CHANGE_IS_COMPARE = `${DATE_PICKER_COMPARATOR_MODULE} CHANGE_IS_COMPARE`;
const CHANGE_DATE_RANGES = `${DATE_PICKER_COMPARATOR_MODULE} CHANGE_DATE_RANGES`;

export const datePickerComparatorActionTypes = {
  CHANGE_IS_COMPARE,
  CHANGE_DATE_RANGES,
};
